import { BannerProps } from "@outschool/ui-legacy-component-library";
import React from "react";

/**
 * If we have anything important to put at the top of every page,
 * put it here in a Banner.
 */

const CompanyNewsBanner: React.FC<BannerProps> = () => null; // right now, now company news to convey

export default CompanyNewsBanner;
